export const ATOMIC_CITY_MUSIC = {
  id: '39b7b689-74c8-42ba-a60b-ecbb9dfc3829',
  type: 'NORMAL',
  links: [
    {
      url: 'https://open.spotify.com/track/22Pn1poD9t6T2fcstx5VQj',
      type: 'SPOTIFY',
      order: 0
    },
    {
      url: 'https://music.apple.com/us/album/atomic-city-mike-will-made-it-remix/1720787653?i=1720787910',
      type: 'APPLE_MUSIC',
      order: 1
    },
    {
      url: 'https://music.youtube.com/watch?v=LFHFTsjigPw',
      type: 'YOUTUBE_MUSIC',
      order: 2
    },
    {
      url: 'https://www.deezer.com/track/2580945862',
      type: 'DEEZER',
      order: 3
    }
  ],
  order: 0,
  artists: [],
  urlSlug: 'atomic-city--mike-will-madeit-remix',
  visible: true,
  metadata: {
    name: 'Atomic City - Mike WiLL Made-It Remix',
    type: 'TRACK',
    images: [
      {
        url: 'https://i.scdn.co/image/ab67616d0000b2734548047e8f66e3896abb2194',
        width: 640,
        height: 640
      }
    ],
    length: 207,
    artists: [
      {
        name: 'U2'
      },
      {
        name: 'Mike WiLL Made-It'
      }
    ],
    albumName: 'Atomic City (Mike WiLL Made-It Remix)',
    previewUrl:
      'https://audio-ssl.itunes.apple.com/itunes-assets/AudioPreview126/v4/99/38/2a/99382a82-99a4-23de-b124-b94d8de5d1e7/mzaf_14365377404786663612.plus.aac.p.m4a',
    externalIds: {
      upc: '00602458975659',
      isrc: 'GBUM72310720'
    },
    releaseYear: 2023,
    resourceIds: {
      ALBUM: '69sOXcC8u5RrYCszDSCM9S',
      TRACK: '22Pn1poD9t6T2fcstx5VQj'
    }
  }
}

export const TURN_ON_THE_LIGHTS_AGAIN_MUSIC = {
  type: 'NORMAL',
  links: [
    {
      url: 'https://open.spotify.com/track/6gdDu39yYqPcaTgCwYEW8i',
      type: 'SPOTIFY',
      isVisible: true
    },
    {
      url: 'https://music.apple.com/us/album/turn-on-the-lights-again-feat-future/1676669792?i=1676670256',
      type: 'APPLE_MUSIC',
      isVisible: true,
      previewUrl:
        'https://audio-ssl.itunes.apple.com/itunes-assets/AudioPreview116/v4/3f/54/f7/3f54f7f3-b1cb-801b-80e7-c3aa2878b9c9/mzaf_1935685357412859076.plus.aac.p.m4a'
    },
    {
      url: 'https://music.youtube.com/watch?v=rhUxOB7F-jk',
      type: 'YOUTUBE_MUSIC',
      isVisible: true
    },
    {
      url: 'https://www.deezer.com/track/1832599647',
      type: 'DEEZER',
      isVisible: true,
      previewUrl:
        'https://cdns-preview-6.dzcdn.net/stream/c-66d198d456ae2d28e4ff22259362ee63-3.mp3'
    }
  ],
  urlSlug: 'turn-on-the-lights-again-feat-future',
  visible: true,
  isUpdate: true,
  metadata: {
    name: 'Turn On The Lights again.. (feat. Future)',
    type: 'TRACK',
    images: [
      {
        url: 'https://i.scdn.co/image/ab67616d0000b273444f129bbe6366c18d533650',
        width: 640,
        height: 640
      }
    ],
    length: 268,
    artists: [
      {
        name: 'Fred again..'
      },
      {
        name: 'Swedish House Mafia'
      },
      {
        name: 'Future'
      }
    ],
    albumName: 'USB',
    previewUrl:
      'https://audio-ssl.itunes.apple.com/itunes-assets/AudioPreview116/v4/3f/54/f7/3f54f7f3-b1cb-801b-80e7-c3aa2878b9c9/mzaf_1935685357412859076.plus.aac.p.m4a',
    externalIds: {
      upc: '5054197615252',
      isrc: 'GBAHS2201001'
    },
    releaseYear: 2022,
    resourceIds: {
      ALBUM: '4NGzLSTgDOfMFPEQvB5MDc',
      TRACK: '0UZFTyq4ogQ5RvfOHGPVdZ'
    },
    externalUrls: {}
  }
}

export const ON_MY_MIND_MUSIC = {
  type: 'NORMAL',
  links: [
    {
      url: 'https://open.spotify.com/track/5lXY6PTuWXOludKy4zDQwM',
      type: 'SPOTIFY',
      isVisible: true
    }
  ],
  order: 1,
  urlSlug: 'on-my-mind',
  visible: true,
  metadata: {
    name: 'On My Mind',
    type: 'TRACK',
    images: [
      {
        url: 'https://i.scdn.co/image/ab67616d0000b27341cdac44ad3dd7f37fd8e9a9',
        width: 640,
        height: 640
      }
    ],
    length: 189,
    artists: [
      {
        name: 'Diplo'
      },
      {
        name: 'SIDEPIECE'
      }
    ],
    albumName: 'Do You Dance?',
    externalIds: {
      upc: '810072040565',
      isrc: 'USZ4V1900134'
    },
    releaseYear: 2021,
    resourceIds: {
      ALBUM: '6Az907HDvldO5qxqVyysz0',
      TRACK: '54hA0ldJYyT1huGfSeOjdQ'
    },
    externalUrls: {}
  }
}

export const LOCKED_UP_MUSIC = {
  type: 'NORMAL',
  links: [
    {
      url: 'https://open.spotify.com/track/7kITGCwFNyrwG98FQTjM53',
      type: 'SPOTIFY',
      isVisible: true
    },
    {
      url: 'https://music.apple.com/us/album/locked-up/1698961901?i=1698961903',
      type: 'APPLE_MUSIC',
      isVisible: true,
      previewUrl:
        'https://audio-ssl.itunes.apple.com/itunes-assets/AudioPreview126/v4/5e/2d/75/5e2d7514-2f43-d8f3-51e2-653f5022d45d/mzaf_3328970847819539898.plus.aac.p.m4a'
    },
    {
      url: 'https://music.youtube.com/watch?v=0_3JPgLuy-E',
      type: 'YOUTUBE_MUSIC',
      isVisible: true
    },
    {
      url: 'https://www.deezer.com/track/2381346905',
      type: 'DEEZER',
      isVisible: true,
      previewUrl:
        'https://cdns-preview-6.dzcdn.net/stream/c-66baeb584a01f775f6fef2633b37bd4e-3.mp3'
    }
  ],
  urlSlug: 'locked-up-ft-akon',
  visible: true,
  metadata: {
    name: 'Locked Up (ft. Akon)',
    type: 'TRACK',
    images: [
      {
        url: 'https://i.scdn.co/image/ab67616d0000b273e913e1bd44389b2837f419df',
        width: 640,
        height: 640
      }
    ],
    length: 147,
    artists: [
      {
        name: 'Steve Aoki'
      },
      {
        name: 'Trinix'
      },
      {
        name: 'Akon'
      }
    ],
    albumName: 'Locked Up (ft. Akon)',
    previewUrl:
      'https://audio-ssl.itunes.apple.com/itunes-assets/AudioPreview126/v4/5e/2d/75/5e2d7514-2f43-d8f3-51e2-653f5022d45d/mzaf_3328970847819539898.plus.aac.p.m4a',
    externalIds: {
      upc: '196922568008',
      isrc: 'USA2P2337662'
    },
    releaseYear: 2023,
    resourceIds: {
      ALBUM: '4eUAfbKPrliNUtflCe6sEu',
      TRACK: '7kITGCwFNyrwG98FQTjM53'
    },
    externalUrls: {}
  }
}

export const PURSUIT_OF_HAPPINESS_MUSIC = {
  type: 'NORMAL',
  links: [
    {
      url: 'https://open.spotify.com/track/7m47Go71qTMBs4kTH7U8F8',
      type: 'SPOTIFY',
      isVisible: true
    }
  ],
  order: 3,
  urlSlug: 'pursuit-of-happiness--extended-steve-aoki-remix',
  visible: true,
  metadata: {
    name: 'Pursuit Of Happiness - Extended Steve Aoki Remix',
    type: 'TRACK',
    images: [
      {
        url: 'https://i.scdn.co/image/ab67616d0000b273b1fa99e25a08df48d03134cc',
        width: 640,
        height: 640
      }
    ],
    length: 374,
    artists: [
      {
        name: 'Kid Cudi'
      },
      {
        name: 'MGMT'
      },
      {
        name: 'Ratatat'
      },
      {
        name: 'Steve Aoki'
      }
    ],
    albumName: 'Pursuit Of Happiness (International Version)',
    externalIds: {
      upc: '00602527335469',
      isrc: 'USUM70917762'
    },
    releaseYear: 2010,
    resourceIds: {
      ALBUM: '5wgcGZb5ESiAS30iiPyNwq',
      TRACK: '7m47Go71qTMBs4kTH7U8F8'
    },
    externalUrls: {}
  }
}

export const JASON_DERULO_VIDEO = {
  id: 'a63d8dab-4110-4c0b-a4ab-6a45cd135cf7',
  url: 'https://www.youtube.com/watch?v=02KkxftGSgI',
  order: 0,
  visible: true,
  metadata: {
    html: '<iframe width="200" height="113" src="https://www.youtube.com/embed/02KkxftGSgI?feature=oembed" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen title="Jason Derulo - Glad U Came (Official Music Video)"></iframe>',
    type: 'video',
    title: 'Jason Derulo - Glad U Came (Official Music Video)',
    width: 200,
    height: 113,
    version: '1.0',
    author_url: 'https://www.youtube.com/@JasonDerulo',
    author_name: 'Jason Derulo',
    provider_url: 'https://www.youtube.com/',
    provider_name: 'YouTube',
    thumbnail_url: 'https://i.ytimg.com/vi/02KkxftGSgI/hqdefault.jpg',
    thumbnail_width: 480,
    thumbnail_height: 360
  }
}
export const MAJID_JORDAN_VIDEO = {
  id: '4065e153-4ae1-4b53-a3e2-716e2d2860b6',
  url: 'https://www.youtube.com/watch?v=_LqU_BOGCbo',
  order: 1,
  visible: true,
  metadata: {
    html: '<iframe width="200" height="150" src="https://www.youtube.com/embed/_LqU_BOGCbo?feature=oembed" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen title="Majid Jordan - Waiting For You (ft. Naomi Sharon) [Official Visualizer]"></iframe>',
    type: 'video',
    title:
      'Majid Jordan - Waiting For You (ft. Naomi Sharon) [Official Visualizer]',
    width: 200,
    height: 150,
    version: '1.0',
    author_url: 'https://www.youtube.com/@majidjordan',
    author_name: 'MAJID JORDAN',
    provider_url: 'https://www.youtube.com/',
    provider_name: 'YouTube',
    thumbnail_url: 'https://i.ytimg.com/vi/_LqU_BOGCbo/hqdefault.jpg',
    thumbnail_width: 480,
    thumbnail_height: 360
  }
}

export const STAY_INFORMED_FORM = {
  form: {
    name: 'Updates',
    fields: [
      {
        name: 'EMAIL_ADDRESS',
        type: 'EMAIL_ADDRESS',
        label: 'Enter email',
        order: 1,
        required: true
      },
      {
        name: 'INPUT',
        type: 'INPUT',
        label: 'Name',
        order: 0,
        required: true
      }
    ]
  },
  order: 0,
  title: 'Exclusive updates',
  layout: 'left',
  visible: true,
  subTitle: 'Receive updates and exclusive discounts',
  enableImage: false
}

export const U2_STAY_VIDEO = {
  metadata: {
    title: 'U2 – Stay (Faraway, So Close) (Official Lyric Video)',
    author_name: 'U2',
    author_url: 'https://www.youtube.com/@U2official',
    type: 'video',
    height: 113,
    width: 200,
    version: '1.0',
    provider_name: 'YouTube',
    provider_url: 'https://www.youtube.com/',
    thumbnail_height: 360,
    thumbnail_width: 480,
    thumbnail_url: 'https://i.ytimg.com/vi/uBz3pfvjz94/hqdefault.jpg',
    html: '<iframe width="200" height="113" src="https://www.youtube.com/embed/uBz3pfvjz94?feature=oembed" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen title="U2 – Stay (Faraway, So Close) (Official Lyric Video)"></iframe>'
  },
  url: 'https://youtu.be/uBz3pfvjz94?si=g8zc6FP5vmXDOSVO',
  order: 2,
  visible: true
}

export const TSHIRT_PRODUCT_1 = {
  id: '5d717fb5-ec81-4c04-bd13-44247d6ca65f',
  url: 'https://everpress.com/slothboogie-discoteca',
  order: 0,
  price: 30,
  title: 'BENVENUTO IN DISCOTECA',
  visible: true,
  currency: 'GBP',
  thumbnail:
    'https://komi-production-assets.s3-accelerate.amazonaws.com/photos/rKN8M5OWMC3TqWKevFaBK.png'
}

export const TSHIRT_PRODUCT_2 = {
  id: '5e29d801-5e41-4381-b442-5596ea6660d3',
  url: 'https://everpress.com/fresh-and-delicious',
  order: 1,
  price: 26,
  title: 'FRESH AND DELICIOUS',
  visible: true,
  currency: 'GBP',
  thumbnail:
    'https://komi-production-assets.s3-accelerate.amazonaws.com/photos/LW9bjBuxRGJ9gS2JSQhr1.png'
}

export const TSHIRT_PRODUCT_3 = {
  id: '700ef58c-6a9e-410d-934f-880db73cf7e0',
  url: 'https://everpress.com/human-after-all-pod-5',
  order: 2,
  price: 26,
  title: 'HUMAN AFTER ALL',
  visible: true,
  currency: 'GBP',
  thumbnail:
    'https://komi-production-assets.s3-accelerate.amazonaws.com/photos/t7l1nEmwG_r5JrE9vRAsY.png'
}
